import { render, staticRenderFns } from "./CatalogFastDelivery.vue?vue&type=template&id=4262c293"
import script from "./CatalogFastDelivery.vue?vue&type=script&lang=ts"
export * from "./CatalogFastDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports